let toastEl: HTMLDivElement | null = null;
let toastTimer: ReturnType<typeof setTimeout> | null = null;

export function copyToClipboard(text: string) {
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(showCopyToast).catch(() => fallbackCopy(text));
    } else {
        fallbackCopy(text);
    }
}

function fallbackCopy(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.cssText = 'position:fixed;left:-9999px;top:-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy');
        showCopyToast();
    } catch {}
    document.body.removeChild(textarea);
}

function showCopyToast() {
    if (toastTimer) clearTimeout(toastTimer);

    if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'fixed bottom-4 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-neutral text-neutral-content text-sm rounded shadow-lg z-[100] transition-opacity';
        document.body.appendChild(toastEl);
    }

    toastEl.textContent = 'Скопировано';
    toastEl.style.opacity = '1';

    toastTimer = setTimeout(() => {
        if (toastEl) toastEl.style.opacity = '0';
        toastTimer = setTimeout(() => {
            if (toastEl) { toastEl.remove(); toastEl = null; }
        }, 300);
    }, 1500);
}
